import React, {useEffect, useState} from "react";
import type { ContextProps } from '../../types';
import {PageTitle} from "../../Components/Landmarks";
import {GridCell, GridContainer} from "../../Components/Grid";
import {Button, SelectField} from "../../Components/Inputs";
import {isNullOrUndefined} from "../../Utilities/commonUtilities";
import {getPrinterName, getUpdatedLabelXml} from "./dymoPrintLabelUtilities";
import {HtmlDisplay} from "../../Components/Display";
import {LayoutFullBleed, LayoutSmall} from "../../Components/Layout";
import {libraryCatalogApi} from "../Library/libraryCatalogApi";
import {useInput} from "../../Components/Inputs/inputUtility";
import {createListFromArray} from "../../Utilities/Types/listUtilities";
// @ts-ignore
import Dymo from "dymojs";

export const DymoPrintLabelContainer = ({
                                            catalogCopyId,
                                            handleApiCall,
                                            handleReturnRedirect
                                        }: ContextProps) => {

    const barcodeInput = useInput("");

    const [printers, setPrinters] = useState<string | null>(null);
    const [copyDetails, setCopyDetails] = useState<Record<string, unknown> | null>(null);
    const [imageData, setImageData] = useState("");
    const [labelXml, setLabelXml] = useState<string | null>(null);
    const [error, setError] = useState("");

    const dymo = new Dymo();

    const connectedDymoPrinterName = !isNullOrUndefined(printers) ? getPrinterName(printers) : `No DYMO printers found.`;

    const noDymoPrints = isNullOrUndefined(printers);
    const noCopyDetails = !copyDetails;

    const getPrinters = async () => {
        try {
            await dymo.getPrinters().then((printers: string) => setPrinters(printers));
        } catch (errorDetails) {
            setError("Error finding DYMO printers. " + errorDetails);
        }
    }
    const sendToPrinter = async (updatedLabelXml: string) => {
        try {
            await dymo.print(connectedDymoPrinterName, updatedLabelXml);
        } catch (errorDetails) {
            setError("Error during label printing: " + errorDetails);
        }
    }
    const setupLabelPreview = async (updatedLabelXml: string) => {
        try {
            const labelData = await dymo.renderLabel(updatedLabelXml);
            const imageData = `data:image/png;base64, ` + labelData.replace(/"/g, "").replace(/\\/g, "");
            setImageData(imageData);
        } catch (errorDetails) {
            setError("Error building preview: " + errorDetails);
        }
    }

    const handleReturn = () => handleReturnRedirect();

    const handlePrintClick = () => {
        if (labelXml) sendToPrinter(labelXml).then();
    };

    useEffect(() => {
        if (noCopyDetails)
            handleApiCall(() => libraryCatalogApi.getCopyBarcode(catalogCopyId), setCopyDetails);
    }, [catalogCopyId]);

    useEffect(() => {
        if (labelXml)
            setupLabelPreview(labelXml).then();
    }, [labelXml]);

    useEffect(() => {
        if (copyDetails) {
            const details = copyDetails as Record<string, any>;
            const dynamicMainTitle = details.title;
            const dynamicDetails = details.details;
            const dynamicBarcodeText = barcodeInput.value || details.barcodeList[0];

            let updatedLabelXml = getUpdatedLabelXml({dynamicMainTitle, dynamicDetails, dynamicBarcodeText});
            setLabelXml(updatedLabelXml);
        }
    }, [copyDetails, barcodeInput.value]);

    useEffect(() => {
        if (!printers) {
            getPrinters().then();
        }
    }, []);

    if (!copyDetails) return null;
    const barcodeList = createListFromArray((copyDetails as Record<string, any>).barcodeList);

    return <>
        <PageTitle h1={`Print Label`}/>
        <LayoutFullBleed className={`catalog text-center`}>
            {
                error &&
                <HtmlDisplay html={`<p class="alert-color">Warning: <b>${error}</b></p>`}/>
            }
            {
                noCopyDetails &&
                <HtmlDisplay html={`<p class="alert-color">Warning: <b>No details found.</b></p>`}/>
            }
            {
                !noDymoPrints &&
                <HtmlDisplay html={`<p>Available Dymo Printer: <b>${connectedDymoPrinterName}</b></p>`}/>
            }
            {
                noDymoPrints && !noCopyDetails && !error &&
                <HtmlDisplay html={`<p>Building Barcode...</b></p>`}/>
            }
            {
                imageData &&
                <p><img src={imageData} alt={`label preview`}/></p>
            }

            <hr/>
            <LayoutSmall>
                <GridContainer>
                    <SelectField
                        includeDefaultOption={false}
                        label={`Volume Access Number`}
                        name={`sfBarcode`}
                        options={barcodeList}
                        {...barcodeInput}
                    />
                    <GridCell>
                        <Button
                            isPrimary isCollapsed
                            label={'Print Label'}
                            name={`btnPrintLabel`}
                            disabled={noDymoPrints || noCopyDetails}
                            onClick={handlePrintClick}/>
                        <Button
                            isCollapsed
                            label={'Cancel'}
                            name={`btnCancel`}
                            onClick={handleReturn}/>
                    </GridCell>
                </GridContainer>
            </LayoutSmall>
        </LayoutFullBleed>

    </>;
};

